export class Ladder {

   ladderId: string;
   name: string;
   endDate: Date;
   public constructor(init?: Partial<Ladder>) {
      Object.assign(this, init);
   }
}